export default "__VITE_ASSET__2BZ0Npws__"